import React from 'react';

import ScheduleSendOutlinedIcon from '@mui/icons-material/ScheduleSendOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';


import { E_CARD_TYPE } from '../productCartHandler/productCartModule';
import homePageV2Messages from './assets/messages/homePageMessages';

const getFormattedMessage = (intl, messageId) => {
    const message = intl.formatMessage(messageId);
    return `${message !== messageId.id ? message : ''}`;
};


export const cardDeliveryTypeOptionsList = (intl, giftCardDeliveryType) => {
    

    const giftCardDeliveryTypeText = giftCardDeliveryType === E_CARD_TYPE ? [
        {
            icon: <ScheduleSendOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.ScheduleSendOut)
        },
        {
            icon: <LocalPrintshopOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.PrintAtHome)
        },
        {
            icon: <InsertLinkOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.ShareViaMessagingApp)
        }
    ] : [
        {
            icon: <LocalShippingOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.localShippingOut)
        },
        {
            icon: <CardGiftcardOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.deliverToYourDoor)
        },
        {
            icon: <AccessTimeOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.chooseMultipleShippingOption)
        },
        {
            icon: <WorkspacePremiumOutlinedIcon sx={{ '& path': { fill: 'currentColor' } }} />,
            text: getFormattedMessage(intl, homePageV2Messages.premiumPackaging)
        }
    ];

    
    const sortedCardDeliveryTypeOptionsList = giftCardDeliveryTypeText.filter(item => item.text.trim() !== '');

    return sortedCardDeliveryTypeOptionsList;
};
